import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ReactComponent as HandCoinsIcon } from '../../assets/images/svg/hand-coins.svg';
import Paragraph from '../Paragraph/Paragraph';
import themeColors from '../../assets/styles/themeColors';
import { pxToRem } from '../../assets/styles/helper';
import Button from '../Button/Button';
import ConfettiGif from '../../assets/images/confetti.gif';
import config from '../../config';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${pxToRem(16)};
  overflow: hidden;
  background-image: url(${ConfettiGif});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #fff;
`;

const Title = styled.h2`
  margin: ${pxToRem(16)} 0 ${pxToRem(16)} 0;
  font-size: ${pxToRem(20)};
  font-weight: 500;
`;

const Text = styled.p`
  font-size: ${pxToRem(16)};
  margin-bottom: ${pxToRem(4)};
`;

const Highlight = styled.span`
  font-weight: 700;
`;

const Price = styled.div`
  font-size: ${pxToRem(20)};
  margin-bottom: ${pxToRem(20)};
`;

const FinalPrice = styled.p`
  font-size: ${pxToRem(14)};
  margin-bottom: ${pxToRem(20)};
  color: ${themeColors.colorTextSecondary};
`;

const SavingsBox = styled.div`
  background-color: ${themeColors.colorPrimaryLight};
  padding: ${pxToRem(10)};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #cceedb;
  border-radius: ${pxToRem(4)};
  margin-bottom: ${pxToRem(20)};
`;

const SavingInfo = styled(Paragraph)`
  font-size: ${pxToRem(14)};
  color: ${themeColors.colorSuccess};
  svg {
    display: inline-block;
    vertical-align: middle;
    margin-right: ${pxToRem(4)};
  }
`;

const ButtonContainer = styled.div`
  position: absolute;
  bottom: 20px;
  width: 95%;
  display: flex;
  justify-content: center;
`;

const Image = styled.img`
  width: ${pxToRem(180)};
  height: ${pxToRem(180)};
  object-fit: contain;
`;

const OrderConfirmation = ({ wizardData }) => {
  const { t } = useTranslation();
  const { storageProduct } = wizardData;
  const { RootUrl } = useSelector(selectSettings);

  const imageUrl = config.algoliaSearch.imageCode
    .replace('{product_code}', storageProduct.ProductCode)
    .replace('{base_url}', RootUrl);

  return (
    <Container>
      <Image src={encodeURI(imageUrl)} alt="Product Name Value Etc..." />

      <Title>{t('buyWizard.congratulations')}</Title>
      <Text>{t('buyWizard.orderCompleteTitle')}</Text>
      <Price>
        {t('buyWizard.orderCompleteDetail')}{' '}
        <Highlight>2 × {storageProduct?.ShortCaption}</Highlight>
        <br />
        <FinalPrice> at $7,001.92</FinalPrice>
      </Price>
      <SavingsBox>
        <SavingInfo>
          <HandCoinsIcon />
          {t('buyWizard.savingInfo3')}
          <b> $2.80 (4%)</b>
        </SavingInfo>
      </SavingsBox>
      <ButtonContainer>
        <Button
          variant="primaryOutlined"
          textTransform="none"
          style={{ width: '100%' }}
          // onClick={() => setOpen(false)}
        >
          {t('buyWizard.viewOrder')}
        </Button>
      </ButtonContainer>
    </Container>
  );
};

OrderConfirmation.propTypes = {
  wizardData: PropTypes.shape({
    storageProduct: PropTypes.shape({
      ProductCaption: PropTypes.string,
      ProductPrice: PropTypes.number,
      Locations: PropTypes.arrayOf(PropTypes.shape({})),
      ProductCode: PropTypes.string,
      ShortCaption: PropTypes.string,
    }),
  }),
};

export default OrderConfirmation;
